import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "caret", "trigger"]
  static values = { expanded: Boolean }

  connect() {
    // Ensure initial state is properly set
    this.updateUI()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.updateUI()
  }

  updateUI() {
    const content = this.contentTarget
    const caret = this.caretTarget

    if (this.expandedValue) {
      // Expand the content
      const scrollHeight = content.scrollHeight
      content.style.maxHeight = `${scrollHeight}px`
      
      // Rotate caret 180 degrees (pointing up)
      caret.style.transform = "rotate(180deg)"
      
      // Add expanded state class
      this.element.classList.add('expanded')
    } else {
      // Collapse the content
      content.style.maxHeight = "0"
      
      // Reset caret rotation (pointing down)
      caret.style.transform = "rotate(0deg)"
      
      // Remove expanded state class
      this.element.classList.remove('expanded')
    }
  }

  expandedValueChanged() {
    // This method is called automatically when expandedValue changes
    this.updateUI()
  }
} 